// ── localStorage helpers ─────────────────────────────────────────────────────
// Leitura/escrita seguras em localStorage (JSON). Nunca lançam: em navegador
// sem acesso ao storage (aba privada, etc.) devolvem o fallback silenciosamente.
export function loadLS(key, fallback) {
  try { const v = localStorage.getItem(key); return v !== null ? JSON.parse(v) : fallback; } catch { return fallback; }
}
export function saveLS(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
}
